/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* See LICENSE.md in the project root for license terms and full copyright notice.
*--------------------------------------------------------------------------------------------*/

import { ProgressRadial } from "@itwin/itwinui-react";
import styles from "./Loading.module.css";

export const Loading = ({ size }: { size?: 'x-small' | 'small' | 'large' }) => {
  return (
    <div className={styles.spinner}>
      <ProgressRadial indeterminate={true} size={size} />
    </div>
  );
}
